import { styled } from 'styled-components';
import { Flex } from '../../layout/Flex';
import { DOTS_ELEMENTS_GAP, DOTS_ELEMENT_HEIGHT, DOTS_ELEMENT_WIDTH, MAX_WIDTH } from './constants';

interface DotWrapperParams {
    dotsOffset: number;
}

interface DotParams {
    isActive: boolean;
}

export const Slider = styled(Flex).withConfig({ displayName: 'Slider' })`
    flex-direction: row;
    position: relative;
    width: fit-content;
    margin: 0 auto;
    align-items: center;
    overflow: hidden;
    background-color: rgba(0, 0, 0, 0.24);
    border-radius: 12px;
    padding: 2px ${DOTS_ELEMENTS_GAP}px;
    max-width: ${MAX_WIDTH}px;
`;

export const DotWrapper = styled(Flex).withConfig({ displayName: 'DotWrapper' })<DotWrapperParams>`
    flex-direction: row;
    transition: transform .20s ease-out;
    will-change transform;
    gap: ${DOTS_ELEMENTS_GAP}px;
    transform: ${({ dotsOffset }) =>
        `translateX(${(DOTS_ELEMENT_WIDTH + DOTS_ELEMENTS_GAP) * -dotsOffset}px`});

`;

export const Dot = styled(Flex).withConfig({ displayName: 'Dot' })<DotParams>`
    height: ${DOTS_ELEMENT_HEIGHT}px;
    border-radius: 12px;
    background-color: var(--control-tertiary-color);
    transition: 0.2s ease-out;
    transition-property: width, opacity;
    will-change: width, opacity;
    width: ${({ isActive }) => (isActive ? DOTS_ELEMENT_WIDTH * 2 : DOTS_ELEMENT_WIDTH)}px;
    opacity: ${({ isActive }) => (isActive ? 1 : 0.5)};
`;
